import React, { useMemo } from "react";
import { useDashboardData } from "../../AIDashboards/DataDrivenDashboardRenderer/DashboardDataContext";
import { AIChart } from "./AIChart";
/**
 * @param {Object} props
 * @param {Object[]} props.specs
 * @returns {React.ReactNode}
 */
const AICharts = ({ specs = [] }) => {
  const { globalState } = useDashboardData();

  const stateAsKey = useMemo(() => {
    try {
      return JSON.stringify(globalState);
    } catch {
      return String(Date.now());
    }
  }, [globalState]);

  return specs.map((spec, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <AIChart key={i + stateAsKey} spec={spec} />
  ));
};

export default AICharts;
